import { Employee } from './employee/employee';
import { ModaliteReunion } from './modaliteReunion';
import { Prestation } from './prestation';
import { Tache } from './tache';
import { TypeEntretien } from './typeEntretien';

export class RestitutionPrestation {
	id: number;
	prestation: Prestation;
    dateValidQualif: string;
    dateButoirDepot: string;
    dateDepotRestFinale: string;
    type: string;
    prolongation: boolean;
    dateDemarrage: string;
    date1erRv: string;
    dateFinPrev: string;
    heuresPrev: number;
    totalHeures: number;
    heuresBilaterales: number;
    heuresCollectif: number;
    heuresEmployeur: number;
    totalHeuresRestantes: number;
    mobilisationAutreAs: boolean;
    raisonSocialeAutre: string;
    pointVigilance: string;
    organismePecBenef: string;
    consequencesHandicap: string;
    reponsesIdentifiees: string[];
    aidesTechniques: string;
    aidesHumaines: string;
    aidesOrganisationnelles: string;
    mediation: string;
    statutDemandeProlongation: string;
    demarcheAdministrative: boolean;
	demarcheAdministrativeDetails: string;

	constructor(
		options: {
			id?: number;
			prestation?: Prestation;
			dateValidQualif?: string;
			dateButoirDepot?: string;
			dateDepotRestFinale?: string;
			type?: string;
			prolongation?: boolean;
			dateDemarrage?: string;
			date1erRv?: string;
			dateFinPrev?: string;
			heuresPrev?: number;
			totalHeures?: number;
			heuresBilaterales?: number;
			heuresCollectif?: number;
			heuresEmployeur?: number;
			totalHeuresRestantes?: number;
			mobilisationAutreAs?: boolean;
			raisonSocialeAutre?: string;
			pointVigilance?: string;
			organismePecBenef?: string;
			consequencesHandicap?: string;
			reponsesIdentifiees?: string[];
			aidesTechniques?: string;
			aidesHumaines?: string;
			aidesOrganisationnelles?: string;
			mediation?: string;
			statutDemandeProlongation?: string;
			demarcheAdministrative?: boolean;
			demarcheAdministrativeDetails?: string;
		} = {}
	) {
		// this.id = options.id || null;
		// this.description = options.description || null;
		// this.prestation = options.prestation || new Prestation();
		// this.tache = options.tache || new Tache();
		// this.intervenant = options.intervenant || new Employee();
		// this.modaliteReunion = options.modaliteReunion || new ModaliteReunion();
		// this.chargeTravail = options.chargeTravail || null;
		// this.dateEntretien = options.dateEntretien || null;
		// this.dateProchainEntretien = options.dateProchainEntretien || null;
		// this.typeEntretien = options.typeEntretien || new TypeEntretien();
	}
}

export enum ResitutionTypeEnumString {
	FINALE = 'Restitution finale',
	MOIS3 = 'Information restitution à 3 mois',
	MOIS6 = 'Validation restitution à 6 mois',
	MOIS9 = 'Information restitution à 9 mois',
	MOIS12 = 'Validation restitution à 12 mois',
	MOIS15 = 'Information restitution à 15 mois',
}

export enum RestitutionTypeEnum {
	'FINALE' = "FINALE",
	'MOIS3' = 'MOIS3',
	'MOIS6' = 'MOIS6',
	'MOIS9' = 'MOIS9',
	'MOIS12' = 'MOIS15',
	'MOIS15' = 'MOIS15',
}

export enum AideType {
	'AT' = 'AT',
	'AH' = 'AH',
	'AO' = 'AO',
	'MED' = 'MED'
}

export enum AideTypeStringEnum{
	AT = 'Aides techniques',
	AH = 'Aides humaines',
	AO = 'Aides organisationnelles',
	MED = "Médiation et/ou intervention auprès de l’employeur et/ou des collaborateurs et/ou auprès de l’organisme de formation"
}

export enum StatutProlongationEnum{
	'OBJET' = 'OBJET',
	'DEMANDE' = 'DEMANDE',
	'ACCORDE' = 'ACCORDE',
}

export enum StatutProlongationEnumString{
	OBJET = 'Est dans objet',
	DEMANDE = 'Est demandé',
	ACCORDE = 'Est accordé',
}